import {
  Box,
  IconButton,
  Menu,
  Tooltip,
  Typography,
} from "@mui/material";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { Fragment, useState } from "react";


type Props = {
  patient: {
    patientIdentifiers: {
      identifier: string,
      identifier_type: string,
    }[] | undefined,
  } | null | undefined,
}

const PatientIdentifiers = ({ patient }: Props) => {
  const [identifiersOpen, setIdentifiersOpen] = useState<null | HTMLElement>(null);

  const identifiers = patient?.patientIdentifiers?.map(({ identifier, identifier_type }, index) => (<Fragment key={index}>
    <Typography variant="button">{identifier_type}</Typography>
    <Typography variant="body1" gutterBottom>
      <data className="patient-identifier" value={identifier_type}>{identifier}</data>
    </Typography>
  </Fragment>));

  return !!patient?.patientIdentifiers?.length && <>
    <Tooltip title="Patient Identifiers"><IconButton
      size="small"
      onClick={(e) => setIdentifiersOpen(e.currentTarget)}
      sx={{ ml: 1 }}
    >
      <MoreHorizIcon fontSize="small" />
    </IconButton></Tooltip>

    {/* The patient identifiers are always on the page. */}
    {/* If the menu is open, we include them visibly in a dropdown. */}
    <Menu
      open={!!identifiersOpen}
      onClose={() => setIdentifiersOpen(null)}
      anchorEl={identifiersOpen}
    >
      <Box sx={{ p: 1, minWidth: 100 }}>
        {identifiers}
      </Box>
    </Menu>

    {/* If the menu is closed, they're still on the page with `display: none`  */}
    {!identifiersOpen && <Box sx={{ display: "none" }}>{identifiers}</Box>}
  </>
}

export default PatientIdentifiers;
